import React from 'react'

import Layout from 'components/Layout'
import SEO from 'components/SEO'
import styled from 'util/style'

const Contact = styled.div`
  max-width: 60%;
  line-height: 2em;
  margin: 0 auto;
`

export function ContactPage({ data }) {

  return (
    <Layout>
      <SEO title="Contact" />

        <Contact>
            <h2>Contact</h2>
            
            {data && data.prismicAboutPage &&
                <div dangerouslySetInnerHTML={{ __html: data.prismicAboutPage.data.contact.html }} />
            }
        </Contact>
    </Layout>
  )
}

export const query = graphql`
    query contact {
        prismicAboutPage {
            data {
                contact {
                    html
                }
            }
        }
    }
`

export default ContactPage
